import React from 'react';
import './style.css';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

const HeaderQuestion = props => {
  return (
    <div className="App-question">
      <p>{props.description}</p>
    </div>
  );
};

export default withRouter(translate('translations')(HeaderQuestion));



// WEBPACK FOOTER //
// ./src/preference/components/HeaderQuestion/index.js